import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';
import type { StepLineColorScheme } from '..';

export const Wrapper = styled.div<{ colorScheme: StepLineColorScheme }>`
  .rc-steps {
    font-size: 0;
    width: 100%;
    line-height: 1.5;
    display: flex;
  }
  .rc-steps,
  .rc-steps * {
    box-sizing: border-box;
  }

  .rc-steps-item {
    position: relative;
    display: inline-block;
    vertical-align: top;
    flex: 1;
    overflow: hidden;
  }
  .rc-steps-item-container[role='button'] {
    cursor: pointer;
    transition: opacity 0.3s;
  }
  .rc-steps-item-container[role='button']:hover {
    opacity: 0.7;
  }
  .rc-steps-item:last-child {
    flex: none;
  }
  .rc-steps-item:last-child .rc-steps-item-tail,
  .rc-steps-item:last-child .rc-steps-item-title:after {
    display: none;
  }
  .rc-steps-item-container {
    /* display: inline-block; */
  }
  .rc-steps-item-icon,
  .rc-steps-item-content {
    display: inline-block;
    vertical-align: top;
  }
  .rc-steps-item-icon {
    border: 1px solid #cacdd3;
    width: 30px;
    height: 30px;
    line-height: 50px;
    border-radius: 6px;
    text-align: center;
    font-size: 15px;
    font-weight: 600;
    margin-right: 8px;
    transition: background-color 0.3s, border-color 0.3s;
    box-shadow: 0 5px 18px 0 rgb(0 0 0 / 8%);
  }
  .rc-steps-item-icon > .rc-steps-icon {
    line-height: 1;
    top: -1px;
    color: red; // ERROR
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .rc-steps-item-tail {
    position: absolute;
    left: 0;
    width: 100%;
    top: 24px;
    padding: 0 10px;
  }
  .rc-steps-item-tail:after {
    content: '';
    display: inline-block;
    height: 2px;
    border-radius: 1px;
    width: 100%;
    background: red; // ERROR
    transition: background 0.3s;
  }
  .rc-steps-item-content {
    margin-top: 3px;
  }
  .rc-steps-item-title {
    font-size: 14px;
    margin-bottom: 4px;
    color: ${(props) => props.theme.color.blue.default};
    font-weight: 500;
    display: inline-block;
    padding-right: 10px;
    position: relative;
  }
  .rc-steps-item-title:after {
    content: '';
    height: 1px;
    width: 1000px;
    background: #e9e9e9;
    display: block;
    position: absolute;
    top: 0.55em;
    left: 100%;
  }
  .rc-steps-item-subtitle {
    font-size: 12px;
    display: inline-block;
    color: #999;
    margin-left: 8px;
  }
  .rc-steps-item-description {
    font-size: 12px;
    color: #999;
  }

  // Next
  .rc-steps-item-wait {
    & .rc-steps-item-icon {
      background: ${(props) => props.colorScheme.next.dotBackground};
    }
    & .rc-steps-item-icon > .rc-steps-icon {
      color: ${(props) => props.colorScheme.next.dotColor};
    }
    & .rc-steps-item-title {
      color: ${(props) => props.colorScheme.next.labelColor};
    }
    & .rc-steps-item-description {
      color: ${(props) => props.colorScheme.next.descriptionColor};
    }
    & .rc-steps-item-title:after {
      background-color: ${(props) => props.colorScheme.next.lineColor};
    }
    & .rc-steps-item-tail:after {
      background-color: ${(props) => props.colorScheme.next.lineColor};
    }
  }

  // Current
  .rc-steps-item-process {
    & .rc-steps-item-icon {
      background: ${(props) => props.colorScheme.current.dotBackground};
      font-weight: 700;
    }
    & .rc-steps-item-icon > .rc-steps-icon {
      color: ${(props) => props.colorScheme.current.dotColor};
      font-weight: 700;
    }
    & .rc-steps-item-title {
      color: ${(props) => props.colorScheme.current.labelColor};
      font-weight: 700;
    }
    & .rc-steps-item-description {
      color: ${(props) => props.colorScheme.current.descriptionColor};
    }
    & .rc-steps-item-title:after {
      background-color: ${(props) => props.colorScheme.current.lineColor};
    }
    & .rc-steps-item-tail:after {
      background-color: ${(props) => props.colorScheme.current.lineColor};
    }
  }

  // Done
  .rc-steps-item-finish {
    & .rc-steps-item-icon {
      background: ${(props) => props.colorScheme.done.dotBackground};
      border: 1px solid ${(props) => props.colorScheme.current.dotBackground};
    }
    & .rc-steps-item-icon > .rc-steps-icon {
      color: ${(props) => props.colorScheme.done.dotColor};
    }
    & .rc-steps-item-title {
      color: ${(props) => props.colorScheme.done.labelColor};
    }
    & .rc-steps-item-description {
      color: ${(props) => props.colorScheme.done.descriptionColor};
    }
    & .rc-steps-item-title:after {
      background-color: ${(props) => props.colorScheme.done.lineColor};
    }
    & .rc-steps-item-tail:after {
      background-color: ${(props) => props.colorScheme.done.lineColor};
    }
  }

  // Error
  .rc-steps-item-error {
    & .rc-steps-item-icon {
      background: ${(props) => props.colorScheme.error.dotBackground};
    }
    & .rc-steps-item-icon > .rc-steps-icon {
      color: ${(props) => props.colorScheme.error.dotColor};
    }
    & .rc-steps-item-title {
      color: ${(props) => props.colorScheme.error.labelColor};
    }
    & .rc-steps-item-description {
      color: ${(props) => props.colorScheme.error.descriptionColor};
    }
    & .rc-steps-item-title:after {
      background-color: ${(props) => props.colorScheme.error.lineColor};
    }
    & .rc-steps-item-tail:after {
      background-color: ${(props) => props.colorScheme.error.lineColor};
    }
  }

  .rc-steps-item.rc-steps-next-error .rc-steps-item-title:after {
    background: ${(props) => props.theme.color.red.default};
  }

  .rc-steps-small {
    & .rc-steps-item-icon {
      width: 18px;
      height: 18px;
      line-height: 18px;
      text-align: center;
      border-radius: 18px;
      font-size: 12px;
      margin-right: 10px;
    }
    & .rc-steps-item-icon > .rc-steps-icon {
      font-size: 12px;
      font-size: 9px;
      transform: scale(0.75);
      top: -1px;
    }
    & .rc-steps-item-content {
      margin-top: 0;
    }
    & .rc-steps-item-title {
      font-size: 12px;
      margin-bottom: 4px;
      color: #666;
    }
    & .rc-steps-item-description {
      font-size: 12px;
      color: #999;
    }
    & .rc-steps-item-tail {
      top: 8px;
      padding: 0 8px;
    }
    & .rc-steps-item-tail:after {
      height: 1px;
      border-radius: 1px;
      width: 100%;
    }
  }

  .rc-steps-vertical {
    & {
      display: block;
    }
    & .rc-steps-item {
      display: block;
      overflow: visible;
      margin-bottom: 10px;
    }
    & .rc-steps-item-icon {
      float: left;
      ${mediaQuery('small')} {
        line-height: 30px;
        font-size: 14px;
        width: 30px;
        height: 30px;
      }
    }
    & .rc-steps-item-icon-inner {
      margin-right: 16px;
    }
    & .rc-steps-item-content {
      min-height: 48px;
      ${mediaQuery('small')} {
        min-height: 30px;
      }
      overflow: hidden;
      display: block;
    }
    & .rc-steps-item-title {
      line-height: 42px;
      ${mediaQuery('small')} {
        line-height: 30px;
      }
    }
    & .rc-steps-item-title:after {
      display: none;
    }
    & .rc-steps-item-description {
      padding-bottom: 12px;
    }
    & .rc-steps-item-tail {
      position: absolute;
      left: 13px;
      top: 0;
      height: 100%;
      width: 1px;
      padding: 30px 0 4px 0;
      display: none;
    }
    & .rc-steps-item-tail:after {
      height: 100%;
      width: 1px;
    }
    &.rc-steps-small .rc-steps-item-tail {
      position: absolute;
      left: 9px;
      top: 0;
      padding: 22px 0 4px 0;
    }
    &.rc-steps-small .rc-steps-item-title {
      line-height: 18px;
    }
  }

  .rc-steps-horizontal {
    &:not(.rc-steps-label-vertical) .rc-steps-item {
      margin-right: 10px;
    }
    &:not(.rc-steps-label-vertical) .rc-steps-item:last-child {
      margin-right: 0;
    }
    &:not(.rc-steps-label-vertical) .rc-steps-item-tail {
      display: none;
    }
    &:not(.rc-steps-label-vertical) .rc-steps-item-description {
      max-width: 150px;
    }
  }

  .rc-steps-label-vertical {
    & .rc-steps-item {
      overflow: visible;
    }
    & .rc-steps-item-tail {
      padding: 0px 70px;
      margin-left: 73px;
    }
    & .rc-steps-item-content {
      display: block;
      text-align: center;
      margin-top: 8px;
      width: 150px;
    }
    & .rc-steps-item-icon {
      display: inline-block;
      margin-left: 62px;
    }
    & .rc-steps-item-title {
      padding-right: 0;
    }
    & .rc-steps-item-title:after {
      display: none;
    }
    & .rc-steps-item-description {
      text-align: left;
    }
  }
`;
